// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"9cfe6995","448":"3339d312"}[chunkId] + ".chunk.css";
};